import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import formatter from 'utils/formatter';
import { DetailItem } from './DetailItem';

export const ViewDebtorFormReadOnly = ({ contract }: { contract: ContractSearchResponseDTO }) => {
  const { devedor } = contract;
  const endereco = devedor?.endereco;

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
      <DetailItem label="Nome" value={devedor?.nome} />
      <DetailItem label="Documento" value={devedor?.documento} />
      <DetailItem label="Email" value={devedor?.email} />
      <DetailItem label="Telefone" value={devedor?.telefone} />
      <DetailItem label="CEP" value={formatter.cep(endereco?.cep)} />
      <DetailItem label="Uf" value={formatter.cep(endereco?.uf)} />
      <DetailItem label="Municipio" value={formatter.cep(endereco?.municipio)} />  
      <DetailItem label="Logradouro" value={formatter.cep(endereco?.logradouro)} />
      <DetailItem label="Numero" value={formatter.cep(endereco?.numero)} />
      <DetailItem label="Bairro" value={formatter.cep(endereco?.bairro)} />
      <DetailItem label="Complemento" value={formatter.cep(endereco?.complemento)} />
    </Grid>
  );
};